export default "__VITE_ASSET__g6SFqqfF__"